import { locales } from '../../locales/en';
import { openTokensDrawer } from '../../state/modals/state.drawer';
import Button from '../Buttons/Button';
import "./ButtonBuy.linaria.module.css!=!./ButtonBuy?./ButtonBuy.linaria.module.css?css=H4sIAAAAAAAAA9NLLMmNz0qKL01OKykwqs7NzNMtz0wpybCyNCqosK7l0gPLG8PlEyuwyKdXxaeVpGfmGKHyqnMTi9Iz83RzUtNKrCwQyjMMkJXDeTDlRZnpGTD1AACZiu6fAAAA"
const rootStyles = "atm_jb_ucftp2 atm_j3_ucftp2 atm_gz_ftgil2 atm_h0_ftgil2";
const ButtonBuy = (props: {
  disabled: boolean;
}) => {
  const {
    disabled = false
  } = props;
  const label = locales.buttons.buyTokens;
  const handleOnClick = () => openTokensDrawer();
  return <Button title={locales.buttons.purchaseTokens} data-testid="Button__BuyTokens" onClick={handleOnClick} size="small" disabled={disabled} className={rootStyles}>
            {label}
        </Button>;
};
export default ButtonBuy;